/**
 * Preview button of header section on editor page
 */
import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import PreviewIcon from 'react-icons/lib/fa/eye'
import { media, LIGHTER_GRAY } from 'components/styles'
import Text from 'components/common/Text'

const StyledPreviewIcon = styled(PreviewIcon)`
  font-size: 5em;
  height: 30px;
  width: 17px;
  margin-right: 0.1em;
`

const StyledButton = styled.div`
  background-color: #FFF;
  border-color: ${LIGHTER_GRAY};
  border-width: 1px;
  border-style: solid;
  ${media.small`height: 74px;`}
  ${media.huge`height: 74px;`}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7em;
  cursor: pointer;
`

class PreviewButton extends Component {

  render () {
    return (
      <StyledButton onClick={this.props.onClick}>
        <StyledPreviewIcon /> <Text>Preview</Text>
      </StyledButton>
    )
  }
}

PreviewButton.propTypes = {
  onClick: PropTypes.func
}

export default PreviewButton



// WEBPACK FOOTER //
// ./src/components/editor/editorHeader/PreviewButton.js